<template>
  <div class="paper-list">
    <Collapse simple v-model="tableToolsPanel" class="table-tools-panel" accordion>
      <Panel name="filter" hide-arrow>
        <div class="table-tools-panel-title"><Icon class="table-tools-panel-title-icon" type="ios-funnel" />筛选</div>
        <div class="pull-right">
          <Tooltip content="刷新结果">
            <Button @click.stop="refresh" type="text" size="large" icon="ios-refresh"></Button>
          </Tooltip>
          <Divider type="vertical" />
          <Tooltip :content="expandText">
            <Button type="text" size="large" :icon="tableToolsPanel.indexOf('filter')>-1? 'ios-arrow-up':'ios-arrow-down'"></Button>
          </Tooltip>
        </div>
        <div slot="content">
          <div class="padding-top-20"></div>
          <Form ref="filterForm" :model="filterModel" inline :show-message="false" :label-width="110">
            <Row :gutter="8">
              <i-col span="16">
                <FormItem label="标题" prop="title">
                  <Input v-model="filterModel.title" placeholder="输入标题" />
                </FormItem>
              </i-col>
            </Row>
              <i-col span="16">
                <FormItem style="width: 100%; text-align:right">
                  <Button type="primary" size="large" style="width:144px;" @click="refresh">查询</Button>
                  <Divider type="vertical" />
                  <Button type="error" ghost size="large" @click="$refs['filterForm'].resetFields()">重置</Button>
                </FormItem>
              </i-col>
            </Row>
          </Form>
        </div>
      </Panel>
    </Collapse>
    <div class="padding-top-10"></div>
    <div class="text-right">
      <Button type="primary" to="/guarantor-appraisal/new-paper" icon="md-add">新增试卷</Button>
    </div>
    <div class="padding-top-10"></div>
    <!-- <Alert type="success" show-icon><b>导入完成！</b>成功 1 条，失败 0 条。</Alert> -->
    <Table border ref="dataTable"
      size="small"
      stripe
      :columns="columns"
      @on-sort-change="tableSortChange"
      :data="data">
    </Table>
    <Page class="pager"
      :total="totalCount"
      :current="currentPageIndex"
      @on-change="changePageIndex"
      @on-page-size-change="changePageSize"
      size="small"
      show-elevator
      show-total
      show-sizer />
    <Modal v-model="showDetailModal" title="详情" :z-index="900" @on-cancel="closeDetailModal">
      <table class="detail-table" v-if="currentModel&&currentModel.title">
        <tr>
          <th>标题</th>
          <td>{{ currentModel.title }}</td>
        </tr>
        <tr>
          <th>评分表达式</th>
          <td>{{ currentModel.scoreFormula }}</td>
        </tr>
        <tr>
          <th>大题数量</th>
          <td>{{ currentModel.sectionCount }}</td>
        </tr>
        <tr>
          <th>题目数量</th>
          <td>{{ currentModel.questionCount }}</td>
        </tr>
        <tr>
          <th>创建时间</th>
          <td>{{ $moment(currentModel.createTime).format('YYYY-MM-DD HH:mm:ss') }}</td>
        </tr>
      </table>
    </Modal>
    <section-picker :show="showSectionPicker" :paperId="currentItemId" @close-picker="closeSectionPicker"></section-picker>
    <guarantor-picker :show="showGuarantorPicker" :paperId="currentItemId" @close-picker="closeGuarantorPicker"></guarantor-picker>
  </div>
</template>

<script>
import SectionPicker from './SectionPicker.vue'
import GuarantorPicker from './GuarantorPicker.vue'
export default {
  name: 'paper-list',
  props: {
  },
  components: {
    SectionPicker,
    GuarantorPicker
  },
  data () {
    return {
      tableToolsPanel: '',
      columns: [
        {
          title: '标题',
          key: 'title',
          resizable: true,
          sortable: 'custom'
        },
        {
          title: '起始时间',
          key: 'startDate',
          sortKey: 'startDate',
          resizable: true,
          render: (h, params) => {
            return h('span', null, params.row.startDate ? this.$moment(params.row.startDate).format('YYYY-MM-DD HH:mm:ss') : '不限')
          }
        },
        {
          title: '截止时间',
          key: 'endDate',
          sortKey: 'endDate',
          resizable: true,
          render: (h, params) => {
            return h('span', null, params.row.endDate ? this.$moment(params.row.endDate).format('YYYY-MM-DD HH:mm:ss') : '不限')
          }
        },
        {
          title: '大题数量',
          key: 'sectionCount',
          resizable: true,
        },
        {
          title: '题目数量',
          key: 'questionCount',
          resizable: true,
        },
        {
          title: '操作',
          width: 260,
          render: (h, params) => {
            return h('span', null, [
              h('Tooltip', {
                props: {
                  content: '详情',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-list-box'
                  },
                  on: {
                    click: () => {
                      this.currentModel = params.row
                      this.currentItemId = params.row.tid
                      this.showDetailModal = true
                    }
                  }
                }, null)
              ]),
              h('Tooltip', {
                props: {
                  content: '预览试卷',
                  transfer: true
                }
              }, [
                h('Button', {
                  style: {
                    marginLeft: '5px'
                  },
                  props: {
                    type: 'primary',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-desktop'
                  },
                  on: {
                    click: () => {
                      this.goPreviewPaper(params.row.tid)
                    }
                  }
                }, null)
              ]),
              this.checkRolePermitted(['总监管人','管理员'])
              ? h('Tooltip', {
                props: {
                  content: '分发试卷',
                  transfer: true
                }
              }, [
                h('Button', {
                  style: {
                    marginLeft: '5px'
                  },
                  props: {
                    type: 'success',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-paper-plane'
                  },
                  on: {
                    click: () => {
                      this.currentModel = params.row
                      this.currentItemId = params.row.tid
                      this.$nextTick(() => {
                        this.openGuarantorPicker()
                      })
                    }
                  }
                }, null),
              ]) : null,
              this.checkRolePermitted(['总监管人','管理员'])
              ? h('Tooltip', {
                props: {
                  content: '选择大题',
                  transfer: true
                }
              }, [
                h('Button', {
                  style: {
                    marginLeft: '5px'
                  },
                  props: {
                    type: 'info',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-filing'
                  },
                  on: {
                    click: () => {
                      this.currentItemId = params.row.tid
                      this.$nextTick(() => {
                        this.openSectionPicker()
                      })
                    }
                  }
                }, null),
              ]) : null,
              this.checkRolePermitted(['总监管人','管理员'])
              ? h('Tooltip', {
                props: {
                  content: '修改',
                  transfer: true
                }
              }, [
                h('Button', {
                  style: {
                    marginLeft: '5px'
                  },
                  props: {
                    type: 'warning',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-create'
                  },
                  on: {
                    click: () => {
                      // let userId = params.row.id
                      this.$router.push('/guarantor-appraisal/edit-paper/' + params.row.tid)
                    }
                  }
                }, null),
              ]) : null,
              this.checkRolePermitted(['总监管人','管理员'])
              ? h('Tooltip', {
                props: {
                  content: '删除',
                  transfer: true
                }
              }, [
                h('Button', {
                  style: {
                    marginLeft: '5px'
                  },
                  props: {
                    type: 'error',
                    ghost: true,
                    shape: 'circle',
                    icon: 'ios-trash-outline'
                  },
                  on: {
                    click: () => {
                      let tId = params.row.tid
                      this.deleteItem(tId)
                    }
                  }
                }, null)
              ]) : null
            ])
          }
        }
      ],
      data: [],
      pageSize: 10,
      totalCount: 0,
      currentPageIndex: 1,
      filterModel: {
        title: null,
        sortBy: 'tid',
        ascending: false
      },
      currentModel: null,
      showDetailModal: false,
      showSectionPicker: false,
      showGuarantorPicker: false,
      currentItemId: null
    }
  },
  watch: {
    currentPageIndex: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
    pageSize: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
  },
  computed: {
    expandText () {
      return (this.tableToolsPanel.indexOf('filter') > -1 ? '隐藏' : '展开') + '筛选条件'
    }
  },
  mounted () {
    this.initData()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    goPreviewPaper (paperId) {
      this.$router.push(`/guarantor-appraisal/view-paper/${paperId}`)
    },
    openGuarantorPicker () {
      console.log('open picker', this.currentModel.tid)
      this.showGuarantorPicker = true
    },
    closeGuarantorPicker () {
      console.log('close picker')
      this.showGuarantorPicker = false
      this.$nextTick(() => {
        this.currentModel = null
      })
    },
    openSectionPicker () {
      console.log('open picker')
      this.showSectionPicker = true
    },
    closeSectionPicker () {
      console.log('close picker')
      this.showSectionPicker = false
    },
    closeDetailModal () {
      this.currentModel = null
      this.showDetailModal = false
      this.currentItemId = null
    },
    checkRolePermitted (roles) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    refresh () {
      // console.log('123')
      this.initData()
    },
    changePageSize (e) {
      this.pageSize = e
    },
    changePageIndex (e) {
      this.currentPageIndex = e
    },
    tableSortChange (e) {
      if (e.key) {
        this.filterModel.sortBy = e.column.sortKey || e.key
        this.filterModel.ascending = e.order === 'normal' ? null : e.order == 'asc' ? true : false
        this.initData()
      }
    },
    async initData () {
      this.$Spin.show()
      let res = await this.$Api.Appraisal.listPaper(this.filterModel, this.currentPageIndex, this.pageSize).catch(err => {
        this.$Message.error(err.message)
        this.$Spin.hide()
      })
      this.totalCount = res.totalCount
      this.data = res.data
      this.$Spin.hide()
    },
    async deleteItem (tId) {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认删除该试卷么？</p>',
        onOk: async () => {
          // this.$Spin.show()
          await this.$Api.Appraisal.deleteAppraisalPaper(tId).catch(err => {
            this.$Notice.error({
              title: '操作失败!',
              desc: err.message
            })
            // this.$Spin.hide()
            return null
          })
          this.$Message.success('操作成功!')
          this.data.splice(this.data.findIndex(o => {return o.tid === tId}), 1)
          this.totalCount -= 1
        },
        onCancel: () => {
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.table-tools-panel {
  .table-tools-panel-title {
    font-weight: bold;
    display: inline-block;
  }
  .table-tools-panel-title-icon {
    margin-right: 20px;
  }
  .table-tools-panel-title-addon {
    display: inline-block;
    margin-left: 20px;
  }
}
.pager {
  margin: 20px 0;
}
</style>
